import { DialogComponent } from "@syncfusion/ej2-react-popups";
import { FC, useEffect, useState } from "react";
import { getRoutings } from "../../../services/ApiService";
import { useAuth } from "../../../utility/useAuth";
import { Col, Container, Row } from "react-grid-system";
import { DropDownListComponent, Inject } from "@syncfusion/ej2-react-dropdowns";
import { CheckBoxComponent } from "@syncfusion/ej2-react-buttons";
import {
  DateTimePickerComponent,
  MaskedDateTime,
} from "@syncfusion/ej2-react-calendars";
import { LabelText } from "./StartJobModal.styles";

interface IStartJobModal {
  open: boolean;
  onStartJob: (
    jobNumber: string,
    operation: string,
    from?: Date,
    to?: Date,
  ) => void;
  onClose: () => void;
  user: string;
  jobNumber: string;
  jobRouting: number;
}

export const StartJobModal: FC<IStartJobModal> = ({
  open,
  onStartJob,
  onClose,
  user,
  jobNumber,
  jobRouting,
}) => {
  const dialogHeader = "CSM Shopfloor";

  const auth = useAuth();

  useEffect(() => {
    getRoutings(auth, jobNumber).then((routings) => {
      const jobOperation = routings
        .filter((x) => x.routingNumber >= jobRouting)
        .map(({ operation }) => operation);
      setOperations(jobOperation);
      setOperation(jobOperation[0]);
    });
  }, [jobNumber]);

  const [operation, setOperation] = useState("");
  const [operations, setOperations] = useState<string[]>([]);
  const [logPastJob, setLogPastJob] = useState(false);
  const [from, setFrom] = useState<Date>(new Date());
  const [to, setTo] = useState<Date>(new Date());

  const buttons = [
    {
      buttonModel: {
        content: "Yes",
        cssClass: "e-flat",
        isPrimary: true,
      },
      click: () => {
        onStartJob(
          jobNumber,
          operation,
          logPastJob ? from : undefined,
          logPastJob ? to : undefined,
        );
      },
    },
    {
      buttonModel: {
        content: "No",
        cssClass: "e-flat",
      },
      click: () => {
        onClose();
      },
    },
  ];

  const firstPosition = { X: 400, Y: 100 };

  function onOperationChange(args: any) {
    if (args) {
      setOperation(args.value);
    }
  }

  function onChangeLogPastJob(args: any) {
    if (args) {
      setLogPastJob(args.target.checked);
    }
  }

  return (
    <DialogComponent
      width="400px"
      close={onClose}
      header={dialogHeader}
      visible={open}
      showCloseIcon={true}
      buttons={buttons}
      position={firstPosition}
      isModal
    >
      <div className="dialogContent">
        <Container fluid>
          <Row align="stretch">
            <>
              {user}, are you sure that you want to start job {jobNumber}?
            </>
          </Row>
          <Row align="stretch">
            <Col sm={2}>
              <LabelText>Operation</LabelText>
            </Col>
            <Col>
              <DropDownListComponent
                id="ddlelement"
                dataSource={operations}
                value={operation}
                placeholder="Select an operation"
                onChange={onOperationChange}
              />
            </Col>
          </Row>
          <Row align="stretch">
            <CheckBoxComponent
              label="Log past job"
              onChange={onChangeLogPastJob}
            />
          </Row>
          <Row align="stretch">
            <Col sm={2}>
              <LabelText>From</LabelText>
            </Col>
            <Col>
              <DateTimePickerComponent
                id="datetimepickerFrom"
                value={from}
                enableMask={true}
                format="dd/MM/yyyy HH:mm:ss"
                enabled={logPastJob}
                placeholder="Select a date and time"
                onChange={(args: any) => {
                  setFrom(args.value as Date);
                }}
              >
                <Inject services={[MaskedDateTime]} />
              </DateTimePickerComponent>
            </Col>
          </Row>
          <Row align="stretch">
            <Col sm={2}>
              <LabelText>To</LabelText>
            </Col>
            <Col>
              <DateTimePickerComponent
                id="datetimepickerTo"
                enableMask={true}
                format="dd/MM/yyyy HH:mm:ss"
                value={to}
                enabled={logPastJob}
                placeholder="Select a date and time"
                onChange={(args: any) => {
                  setTo(args.value as Date);
                }}
              >
                <Inject services={[MaskedDateTime]} />
              </DateTimePickerComponent>
            </Col>
          </Row>
        </Container>
      </div>
    </DialogComponent>
  );
};
